import { Price } from "./../_models/price";
import { Zone } from "./../_models/zone";
import { City } from "./../_models/city";
import { State } from "./../_models/state";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Courier } from "../_models/courier.js";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PriceService {
  constructor(private http: HttpClient, public auth: AuthService) {}

  public getPricesByZoneId(zoneId: number) {
    const token = localStorage.getItem("prime-token");
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.prices}/ByZone/${zoneId}`;
    return this.http.get<Price[]>(requestUrl, options);
  }

  public getPrice(priceId: number) {
    const token = localStorage.getItem("prime-token");
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.prices}/${priceId}`;
    return this.http.get<Price>(requestUrl, options);
  }

  public addPrice(price: Price) {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.prices}/`;
    console.log(requestUrl);
    return this.http.post<Price>(requestUrl, price, options);
  }

  public updatePrice(price: Price) {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.prices}/${price.id}`;
    console.log(requestUrl);
    return this.http.put<Price>(requestUrl, price, options);
  }

  public deletePrice(priceId: number) {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.prices}/${priceId}`;
    console.log(requestUrl);
    return this.http.delete(requestUrl, options);
  }
}
